import { render, staticRenderFns } from "./ShopSidebarThree.vue?vue&type=template&id=357429eb&"
import script from "./ShopSidebarThree.vue?vue&type=script&lang=js&"
export * from "./ShopSidebarThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357429eb')) {
      api.createRecord('357429eb', component.options)
    } else {
      api.reload('357429eb', component.options)
    }
    module.hot.accept("./ShopSidebarThree.vue?vue&type=template&id=357429eb&", function () {
      api.rerender('357429eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/sidebar/ShopSidebarThree.vue"
export default component.exports